import axios from 'axios';

const STATUS_MESSAGES: Record<number, string> = {
  400: 'Некорректный запрос',
  401: 'Неверный логин или пароль',
  403: 'Доступ запрещён',
  404: 'Ресурс не найден',
  408: 'Превышено время ожидания',
  500: 'Ошибка сервера, попробуйте позже',
  502: 'Сервер временно недоступен',
  503: 'Сервис недоступен',
};

export function parseApiError(
  err: unknown,
  fallback = 'Произошла ошибка, попробуйте позже'
): string {
  if (!axios.isAxiosError(err)) return fallback;
  if (!err.response) return 'Нет соединения с сервером';
  return STATUS_MESSAGES[err.response.status] ?? fallback;
}
